export default __webpack_public_path__ + "static/updated-Img-16b03a78d85490007d7f74d7522970a5.svg";